<ui-card-page>
	<ng-container modal-header>
		<div style="margin-top: 89px;" class="resume_header">
			<img style="width: 112px; height: 112px;" [src]="'assets/images/ibk-place-holder.svg' | locationAssets"
			     alt="ibk"/>
		</div>
	</ng-container>
	<ng-container modal-body>
		<div class="resumen_body">
			<div class="resumen_body__cardholder">
				<div class="resume_header__title_ch">Estás a punto de</div>
				<div class="resume_header__title_ch" style="margin-bottom: 16px;">realizar tu pago</div>
				<div class="resumen_item__title">¿Eres el titular de la</div>
				<div class="resumen_item__title">Tarjeta de Débito que</div>
				<div class="resumen_item__title">usarás para tu</div>
				<div class="resumen_item__title">pago?</div>
			</div>
			<div class="resumen_body__form">
				<ibk-button>
					<button style="width: 249px; height: 44px;"
					        class="ibk-btn ibk-btn--primary"
					        (click)="actionIsOwner($event)">
						Sí, soy el titular.
					</button>
				</ibk-button>
				<ibk-button>
					<button style="width: 249px; height: 44px;"
					        class="ibk-btn ibk-btn--primary ibk-btn--no-bg"
					        (click)="actionIsNotOwner($event)">
						No, la tarjeta es de alguien más.
					</button>
				</ibk-button>
				<div class="alert alert-warning" style="width: 249px;">
					<div class="alert-container">
						<div class="alert-icon" style="float:left; width: 20px;">
							<img style="width: 20px;height: 20px;color: white;" [src]="'assets/icons/info.svg' | locationAssets"
							     alt="ibk"/>
						</div>
						<div style="float:left; width: 80%;">
							Para finalizar tu pago con éxito no cierres la página <b>hasta poder visualizar tu constancia de pago de
							Interbank.</b>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</ui-card-page>
